import createYCloudIcon from '../createYCloudIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm15 10.42 4.8-5.07', key: '10at9d' }],
  ['path', { d: 'M19 18h3', key: 'nnkd4d' }],
  [
    'path',
    {
      d: 'M9.5 22 21.414 9.415A2 2 0 0 0 21.2 6.4l-5.61-4.208A1 1 0 0 0 14 3v2a2 2 0 0 1-1.394 1.906L8.677 8.053A1 1 0 0 0 8 9c-.155 6.393-2.082 9-4 9a2 2 0 0 0 0 4h14',
      key: 'v410ed',
    },
  ],
];

/**
 * @component @name SportShoe
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUgMTAuNDIgNC44LTUuMDciIC8+CiAgPHBhdGggZD0iTTE5IDE4aDMiIC8+CiAgPHBhdGgKICAgIGQ9Ik05LjUgMjIgMjEuNDE0IDkuNDE1QTIgMiAwIDAgMCAyMS4yIDYuNGwtNS42MS00LjIwOEExIDEgMCAwIDAgMTQgM3YyYTIgMiAwIDAgMS0xLjM5NCAxLjkwNkw4LjY3NyA4LjA1M0ExIDEgMCAwIDAgOCA5Yy0uMTU1IDYuMzkzLTIuMDgyIDktNCA5YTIgMiAwIDAgMCAwIDRoMTQiCiAgLz4KPC9zdmc+Cg==) - https://tianjianjun0727.github.io/ycloud-icons/icons/sport-shoe
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/react - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportShoe = createYCloudIcon('sport-shoe', __iconNode);

export default SportShoe;
